import React, { FC } from 'react';

interface StepBarProps {
  totalSteps: number;
  currentStep: number;
}

export const StepBar: FC<StepBarProps> = ({ totalSteps, currentStep }) => {
  return (
    <div>
      <div className="tw-font-normal tw-text-content-tertiary">
        Step {currentStep} of {totalSteps}
      </div>
      <div className="tw-mt-2 tw-flex">
        {[...Array(totalSteps)].map((val, idx) => {
          return (
            <div
              key={`step-${idx}`}
              className={`tw-w-6  tw-rounded-sm tw-border-solid 
              ${currentStep >= idx + 1 ? 'tw-border-primary-blue' : 'tw-border-border-grey'}
              ${idx > 0 ? 'tw-ml-1' : ''}`}
            />
          );
        })}
      </div>
    </div>
  );
};
